/*
* Date sent ranges (used by filters in research components)
*/

import moment from 'moment';
import * as _ from 'lodash';

import AppConfiguration from '../config/configuration';

export class DateRanges {
    public static AllDatesStartDate: string = '1/1/1900';
    public static SinceTwoThousandStartDate: string = '1/1/2000';

    public static DateRangeOptionValues: any = {
        ALL_DATES: 'ALL_DATES',
        END_OF_TODAY: 'END_OF_TODAY',
        LAST_THIRTY_DAYS: 'LAST_THIRTY_DAYS',
        MONTH_TO_DATE: 'MONTH_TO_DATE',
        YEAR_TO_DATE: 'YEAR_TO_DATE',
        PREVIOUS_MONTH: 'PREVIOUS_MONTH',
        PREVIOUS_YEAR: 'PREVIOUS_YEAR',
        LAST_THREE_MONTHS: 'LAST_THREE_MONTHS',
        LAST_SIX_MONTHS: 'LAST_SIX_MONTHS',
        LAST_TWELVE_MONTHS: 'LAST_TWELVE_MONTHS',
        LAST_TWO_YEARS: 'LAST_TWO_YEARS',
        LAST_THREE_YEARS: 'LAST_THREE_YEARS',
        LAST_FOUR_YEARS: 'LAST_FOUR_YEARS',
        LAST_FIVE_YEARS: 'LAST_FIVE_YEARS',
        LAST_SIX_YEARS: 'LAST_SIX_YEARS',
        SINCE_TWO_THOUSAND: 'SINCE_TWO_THOUSAND',
        TOMORROW: 'TOMORROW',
    };

    public static getDateRanges(dateRangeOption: string) {
        // Return object with calculated start and end date range values
        const momentFormat = AppConfiguration.getMomentShortDateFormat();

        let result = {
            startDate: moment(DateRanges.AllDatesStartDate, momentFormat).format(momentFormat),
            endDate: moment().format(momentFormat),
        };

        switch (dateRangeOption) {
            default:
            case DateRanges.DateRangeOptionValues.ALL_DATES:
                {
                    result.startDate = moment(DateRanges.AllDatesStartDate, momentFormat).format(momentFormat);
                    result.endDate = moment().format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.END_OF_TODAY:
                {
                    result.endDate = moment().add(1, 'days').startOf('day').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_THIRTY_DAYS:
                {
                    result.startDate = moment().subtract(30, 'days').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.MONTH_TO_DATE:
                {
                    result.startDate = moment().set('date', 1).format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.YEAR_TO_DATE:
                {
                    result.startDate = moment().set('month', 0).set('date', 1).format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.PREVIOUS_MONTH:
                {
                    result.startDate = moment().subtract(1, 'months').set('date', 1).format(momentFormat);
                    result.endDate = moment().set('date', 1).subtract(1, 'days').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.PREVIOUS_YEAR:
                {
                    result.startDate = moment().subtract(1, 'years').set('date', 1).set('month', 0).format(momentFormat);
                    result.endDate = moment().set('month', 0).set('date', 1).subtract(1, 'days').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_THREE_MONTHS:
                {
                    result.startDate = moment().subtract(3, 'months').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_SIX_MONTHS:
                {
                    result.startDate = moment().subtract(6, 'months').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_TWELVE_MONTHS:
                {
                    result.startDate = moment().subtract(12, 'months').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_TWO_YEARS:
                {
                    result.startDate = moment().subtract(2, 'years').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_THREE_YEARS:
                {
                    result.startDate = moment().subtract(3, 'years').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_FOUR_YEARS:
                {
                    result.startDate = moment().subtract(4, 'years').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_FIVE_YEARS:
                {
                    result.startDate = moment().subtract(5, 'years').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.LAST_SIX_YEARS:
                {
                    result.startDate = moment().subtract(6, 'years').format(momentFormat);
                }
                break;

            case DateRanges.DateRangeOptionValues.SINCE_TWO_THOUSAND:
                {
                    result.startDate = moment(DateRanges.SinceTwoThousandStartDate, momentFormat).format(momentFormat);
                    result.endDate = moment().format(momentFormat);
                }
                break;
            
            case DateRanges.DateRangeOptionValues.TOMORROW:
                {
                    result.startDate = moment().add(1, 'days').startOf('day').format(momentFormat);
                }
                break;
        }

        return result;
    }

    public static getStartDate(dateRangeOption: string) {
        // Return start date for rangeOption
        return DateRanges.getDateRanges(dateRangeOption).startDate;
    }

    public static getEndDate(dateRangeOption: string) {
        // Return end date for rangeOption
        return DateRanges.getDateRanges(dateRangeOption).endDate;
    }

    public static getArray(defaultOption: any): Array<any> {
        // Return new array
        let result = _.stubArray();
        result.push(defaultOption);

        return _.cloneDeep(result);
    }
}



// WEBPACK FOOTER //
// ./src/common/dateranges.tsx